import React, { PropsWithChildren } from 'react';
import MarketStateSnapshotUpdateDate
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/MarketStateSnapshotUpdateDate';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import CalendarMonth from '@app/state/calendar/CalendarMonth';
import ExportToExcelSelectorFragment from '@app/site/secured/rateshopper/rates/dashboard/fragment/export/ExportToExcelSelectorFragment';
import { useMarketStateFilterInputTools } from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';
import {
	RefreshMarketStateButton,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/RefreshMarketStateButton';

const RefreshMarketStateToolbar: React.FunctionComponent<PropsWithChildren<{
	companyHotel: CompanyHotel,
	calendarMonth: CalendarMonth,
	afterUpdateMarketStateButton?: React.ReactNode,
	hideExportButton?: boolean,
}>> = ({ children, companyHotel, calendarMonth, afterUpdateMarketStateButton, hideExportButton }) => {

	const { filter } = useMarketStateFilterInputTools();

	return <div className="lg:flex lg:h-full lg:flex-col">
		{/* Header */}
		<header
			className="flex flex-col gap-3 border-b border-gray-200 pb-4 lg:flex-row lg:items-center lg:justify-between lg:flex-none">
			{!children ? <div /> : children}
			<div className="flex items-center flex-wrap gap-y-2 gap-x-2 lg:justify-end">
				<MarketStateSnapshotUpdateDate calendarMonth={calendarMonth} />
				{!hideExportButton &&
					<ExportToExcelSelectorFragment companyHotel={companyHotel} calendarMonth={calendarMonth} />}
				<RefreshMarketStateButton companyHotel={companyHotel} calendarMonth={calendarMonth} filter={filter} />
				{afterUpdateMarketStateButton}
			</div>
		</header>
	</div>;
};

export default RefreshMarketStateToolbar;
